export default {
	keyDetailsLabel: "Key Points",
	actionItemsLabel: "Recommended Action Items",
	copyToNoteLabel: "Copy to note",
};
